import React from 'react';
import { css } from '@emotion/core';

export default function RatioContainerStyle({
    style,
    ratio = 1,
    enableOuterContainer = true,
    children,
    frameHeight
}) {
    const styles = Array.isArray(style) ? style.map(s => css(s)) : [css(style)];

    const content = (
        <div css={contentWrapperStyle(frameHeight)} className="fever-ratio-container-content">
            {children}
        </div>
    );
    if (enableOuterContainer) {
        return (
            <div css={[containerStyle, ...styles]}>
                <div css={ratioWrapperStyle(ratio)}>{content}</div>
            </div>
        );
    } else {
        return <div css={[ratioWrapperStyle(ratio), ...styles]}>{content}</div>;
    }
}

const containerStyle = css`
    width: 100%;
`;

const ratioWrapperStyle = ratio => css`
    padding-top: ${100 / ratio}%;
    position: relative;
`;

const contentWrapperStyle = frameHeight => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: ${frameHeight ? `${frameHeight}px` : '100%'};
`;
